import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { styled } from 'styled-components';
import { tk, Typography } from '@sunwebgroup/ui-components';

export const Dropdown = {
  Menu: styled(DropdownMenu.Root)``,
  Trigger: styled(DropdownMenu.Trigger)`
    align-items: center;
    border-radius: ${tk('radius_rounded')};
    display: inline-flex;
    flex: 1 0 auto;
    padding: ${tk('spacing_xs')};

    &:hover,
    &[data-state='open'] {
      @media ${tk('mq_desktop_md')} {
        background: ${tk('color_semantic_bg_subdued_hover')};
        color: inherit;
      }
      color: ${tk('color_semantic_text_primary_hover')};
    }

    ${Typography} {
      display: none;
    }

    @media ${tk('mq_desktop_md')} {
      padding: ${tk('spacing_xs')} ${tk('spacing_sm')} ${tk('spacing_xs')} ${tk('spacing_xs')};

      ${Typography} {
        display: inline;
        margin-left: ${tk('spacing_xs')};
      }
    }
  `,
};
